import { useMutation } from "@apollo/client/react"; import React, { useEffect, useMemo, useState } from "react";
import { Grid } from "@mui/material";
import CardBox from "../../CardBox/CardBox";
import { RenderInputByTypeMobile } from "../../../../../../components/formGroupGenerator/RenderInputByTypeMobile";
import SAVE_PROCEDIMIENTO_CP, { adaptAddPresencialProcedimientoCPInput } from "../../../../../../data/graphQL/mutations/Visitas/saveProcedimientoCP";
// import ES_ENFERMERO_GUARDIA_NO_CORRESPONDE from "../../../../../data/graphQL/queries/MisVisitas/esE"
import { useVisita } from "../../../../../../context/VisitaContext";

import { useStepSave } from "../../../../hooks/useStepSave";
import { validateStepFields } from "../../../../utils/visitaStepValidation";

export default function ProcedimientoCP({ esUrgencia, readOnly, isClone, onSaveRef, onExposeFormatted, esEnfermeroCuidador }) {
  const [formData, setFormData] = useState({});

  const { visita, setVisita } = useVisita();

  //QUERY y MUTATION
  const [save] = useMutation(SAVE_PROCEDIMIENTO_CP);

  const formattedInputs = useMemo(() => {
    return inputs.map((input) => {
      const newInput = { ...input };

      if (newInput.name === 'tensionArterial') newInput.required = visita?.edad > 15 && !!formData?.controlSignosVitales;

      if (newInput.name === 'cambioSondaVesical' && !!isClone) newInput.disabled = true;

      if (newInput.name === 'justifSinSignos') newInput.required = !formData?.controlSignosVitales;

      if (!['spo2','justifSinSignos','otros'].includes(newInput.name)) newInput.required = !!formData?.controlSignosVitales;

      if (esUrgencia) newInput.required = false;

      if (esEnfermeroCuidador) {
        if (newInput.name !== 'adminMedicamentos' && newInput.name !== 'otros')
          newInput.hidden = true; else
          newInput.required = false;
      }

      if (readOnly) newInput.disabled = true;

      return newInput;
    });
  }, [readOnly, esUrgencia, isClone, esEnfermeroCuidador,formData?.controlSignosVitales,visita?.edad]);

  const handleChange = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  useStepSave(onSaveRef, async (validate) => {
    if (validate) validateStepFields({ formattedInputs, formData });

    const { data } = await save({ variables: { input: adaptAddPresencialProcedimientoCPInput(formData) } });

    const idPresencialCPCDNuevo = data?.saveVisitaPresencialCPProcedimiento?.idPresencialCPCD;
    if (!idPresencialCPCDNuevo) throw new Error("Error al guardar");

    setVisita((prev) => ({
      ...prev,
      ...formData,
      idPresencialCPCD: idPresencialCPCDNuevo
    }));

  });

  useEffect(() => {
    setFormData(visita);
  }, [visita]);

  useEffect(() => {
    onExposeFormatted?.({
      stepId: 'procedimientoCP',
      stepName: 'Procedimiento CP',
      formattedInputs
    });
  }, [onExposeFormatted, formattedInputs]);

  return (
    <CardBox title="Procedimiento">
      <Grid container spacing={2}>
        {formattedInputs.
          filter((input) => !input.hidden).
          map((input) =>
            <Grid size={{ xs: input.halfSpace ? 6 : 12 }} key={input.name}>
              <RenderInputByTypeMobile
                key={`${input.name}-${input.type}${input.type === 'multiple_boolean' ? formData[input.name] : ''}`}
                label={input.displayName}
                value={formData[input.name]}
                handleChange={handleChange}
                row={input.type === "multiple_boolean"}
                input={input} />

            </Grid>
          )}
      </Grid>
    </CardBox>);

}
const inputs = [
  {
    name: "controlSignosVitales",
    displayName: "Control de signos vitales",
    type: "boolean",
    required: true,
    lightTitle: true
  },
  {
    name: "justifSinSignos",
    displayName: "Justificación sin signos vitales",
    type: "long_string",
    maxLength: 4000,
  },
  {
    name: "tensionArterial",
    displayName: "Tensión arterial",
    type: "string",
    halfSpace: true
  },
  {
    name: "temperatura",
    displayName: "Temperatura",
    type: "float",
    required: true,
    halfSpace: true
  },
  {
    name: "frecuenciaRespiratoria",
    displayName: "F. Respiratoria",
    type: "float",
    required: true,
    halfSpace: true
  },
  {
    name: "spo2",
    displayName: "SPO2",
    type: "float",
    required: false,
    halfSpace: true
  },
  {
    name: "frecuenciaCardiaca",
    displayName: "F. Cardiaca",
    type: "float",
    required: true,
    halfSpace: true
  },
  {
    name: "cambioSondaVesical",
    displayName: "Cambio de Sonda vesical",
    type: "boolean",
    lightTitle: true,
    required: true
  },
  {
    name: "aspiracionSecreciones",
    displayName: "Aspiración de secreciones",
    type: "boolean",
    lightTitle: true,
    required: true
  },
  {
    name: "curacionLesiones",
    displayName: "Curación de lesiones",
    type: "boolean",
    lightTitle: true,
    required: true
  },
  {
    name: "adminMedicamentos",
    displayName: "Administración de medicamentos",
    type: "boolean",
    lightTitle: true,
    required: true
  },
  {
    name: "otros",
    displayName: "Otros",
    type: "long_string",
    maxLength: 250,
    required: false
  }];